import * as cookie from '../cookie'

const LOCALE_COOKIE = '__locale'
const DIRECTION_COOKIE = '__direction'

export function getLocale() {
  return cookie.get(LOCALE_COOKIE) || 'en'
}

export function saveLocale(locale) {
  cookie.set(LOCALE_COOKIE, locale)
}

export function getDirection() {
  return cookie.get(DIRECTION_COOKIE) || 'ltr'
}

export function saveDirection(dir) {
  cookie.set(DIRECTION_COOKIE, dir)
}
